var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountrySg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7861)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7861",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7861)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6667H28V0H0V10.6667Z",
    fill: "#E12237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 9.33337C7.61186 9.33337 8.48041 9.0056 9.16493 8.45752C8.80232 8.59277 8.40984 8.66671 8.00008 8.66671C6.15913 8.66671 4.66675 7.17432 4.66675 5.33337C4.66675 3.49242 6.15913 2.00004 8.00008 2.00004C8.40984 2.00004 8.80232 2.07397 9.16493 2.20923C8.48041 1.66115 7.61186 1.33337 6.66675 1.33337C4.45761 1.33337 2.66675 3.12423 2.66675 5.33337C2.66675 7.54251 4.45761 9.33337 6.66675 9.33337ZM8.00008 4.66671C8.00008 5.0349 7.7016 5.33337 7.33341 5.33337C6.96522 5.33337 6.66675 5.0349 6.66675 4.66671C6.66675 4.29852 6.96522 4.00004 7.33341 4.00004C7.7016 4.00004 8.00008 4.29852 8.00008 4.66671ZM8.66675 8.00004C9.03494 8.00004 9.33342 7.70156 9.33342 7.33337C9.33342 6.96518 9.03494 6.66671 8.66675 6.66671C8.29856 6.66671 8.00008 6.96518 8.00008 7.33337C8.00008 7.70156 8.29856 8.00004 8.66675 8.00004ZM12.0001 7.33337C12.0001 7.70156 11.7016 8.00004 11.3334 8.00004C10.9652 8.00004 10.6667 7.70156 10.6667 7.33337C10.6667 6.96518 10.9652 6.66671 11.3334 6.66671C11.7016 6.66671 12.0001 6.96518 12.0001 7.33337ZM12.6667 5.33337C13.0349 5.33337 13.3334 5.0349 13.3334 4.66671C13.3334 4.29852 13.0349 4.00004 12.6667 4.00004C12.2986 4.00004 12.0001 4.29852 12.0001 4.66671C12.0001 5.0349 12.2986 5.33337 12.6667 5.33337ZM10.6667 2.66671C10.6667 3.0349 10.3683 3.33337 10.0001 3.33337C9.63189 3.33337 9.33341 3.0349 9.33341 2.66671C9.33341 2.29852 9.63189 2.00004 10.0001 2.00004C10.3683 2.00004 10.6667 2.29852 10.6667 2.66671Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7861"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrySg);
export default __webpack_public_path__ + "static/media/Country=SG.92ffb2ae17f730fe30c3547b7bb9f105.svg";
export { ForwardRef as ReactComponent };